import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { UserProfile } from 'src/app/core/models/initials.model';
import { PreInitials } from '../../models/pre-initial.models';
import { Profile } from '../../models/user.model';
import { ProfileGatewayService } from './profile-gateway.service';


@Injectable({ providedIn: 'root' })

export class ProfileFacadeService {
  constructor(private profileGatewayService: ProfileGatewayService) { }

  getUserProfile(): Observable<UserProfile> {
    return this.profileGatewayService.getUserProfile();
  }
  
  getCompanyProfile(): Observable<Profile> {
    return this.profileGatewayService.getCompanyProfile();
  }

  userUpdateProfile(data: any, id?): Observable<Profile> {
    return this.profileGatewayService.userUpdateProfile(data, id);
  }

  getPreInitials(): Observable<PreInitials> {
    return this.profileGatewayService.getPreInitials();
  }
}
